import { Input, Select, Text, type TypeSelectOption } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import { SearchFilter } from '~/components/common';

import type { TypeExchangeItemAddFilterValues, TypeExchangeItemAddFilterValuesState } from '~/types/claim.types';

import styles from '../ClaimExchangeItemAddModal.module.scss';

const ClaimExchangeItemAddFilter = ({
  values,
  valuesState,
  options,
  onChange,
  onChangeState,
  onSearch,
  onReset,
}: {
  values: TypeExchangeItemAddFilterValues;
  valuesState: TypeExchangeItemAddFilterValuesState;
  options: { keywordType: TypeSelectOption<string>[] };
  onChange: (values: Partial<TypeExchangeItemAddFilterValues>) => void;
  onChangeState: (valuesState: Partial<TypeExchangeItemAddFilterValuesState>) => void;
  onSearch: () => void;
  onReset: () => void;
}) => {
  return (
    <SearchFilter formId="claim-exchange-item-add-form" onSubmit={onSearch} onReset={onReset}>
      <div className={clsx(styles['filter-container'], styles['filter-keyword'])}>
        <Text size="small" weight="semi-bold" element="p">
          키워드
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.keywordType}
            value={values.keywordType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => {
              if (value?.value === values.keywordType?.value) return;
              onChange({ keywordType: value, keyword: '' });
              onChangeState({ keyword: 'default' });
            }}
          />
          <Input
            type="text"
            size="small"
            placeholder="입력"
            status={valuesState.keyword}
            value={values.keyword}
            onChange={(e) => onChange({ keyword: e.target.value })}
            onBlur={(e) => onChange({ keyword: e.target.value.trim() })}
            onFocus={() => onChangeState({ keyword: 'default' })}
          />
        </div>
      </div>
    </SearchFilter>
  );
};

export default ClaimExchangeItemAddFilter;
